module.exports = __webpack_public_path__ + "img/success-square.af19b266.svg";